import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { paginatedSchema } from "../pagination";

import { baseAssetWithTimeseriesSchema } from "./assetsBase";

export const sluiceListItemSchema = baseAssetWithTimeseriesSchema.extend({
  name: z.string(),
});

export type SluiceListItem = z.infer<typeof sluiceListItemSchema>;

export const sluiceListSchema = paginatedSchema(sluiceListItemSchema);
export type SluiceList = z.infer<typeof sluiceListSchema>;

export const sluiceSchema = sluiceListItemSchema;
export type Sluice = z.infer<typeof sluiceSchema>;

export function useSluices(params = {}) {
  const url = combineUrlAndParams("/api/v4/sluices/", params);
  return useParsedQuery<SluiceList>(
    ["lizard-api-v4", "sluices", url],
    () => fetchWithError(url),
    (json: unknown) => sluiceListSchema.parse(json)
  );
}

export function useSluice(id: number) {
  return useParsedQuery<Sluice>(
    ["lizard-api-v4", "sluices", id],
    () => fetchWithError(`/api/v4/sluices/${id}/`),
    (json: unknown) => sluiceSchema.parse(json)
  );
}

export function useMultipleSluices(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "sluices", id],
        fetchFunction: () => fetchWithError(`/api/v4/sluices/${id}/`),
        parseFunction: (json: unknown) => sluiceSchema.parse(json),
      };
    })
  );
}
